<div class="confirm-dialog-body">
  <div class="content-container">
    <span class="content-span">{{data.message1}}</span>
  </div>
  <div class="actions-container">
    <button class="dialog-btn dialog-btn-confirm" [mat-dialog-close]="true">OK</button>
  </div>
</div>